import { useState, useCallback } from 'react';

interface UseModalReturn {
  isOpen: boolean;
  isClosing: boolean;
  openModal: () => void;
  closeModal: () => void;
  closeWithAnimation: () => void;
}

export const useModal = (initialState = false): UseModalReturn => {
  const [isOpen, setIsOpen] = useState(initialState);
  const [isClosing, setIsClosing] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
    setIsClosing(false);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setIsClosing(false);
  }, []);

  const closeWithAnimation = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 200); // Match animation duration
  }, []);

  return {
    isOpen,
    isClosing,
    openModal,
    closeModal,
    closeWithAnimation,
  };
};
